var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 379.67 67.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3866a2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.31,34.06c0,10.25-7.35,17.48-17.51,17.48S73.28,44.31,73.28,34.06c0-9.58,8.4-16.3,17.52-16.3S108.31,24.48,108.31,34.06Zm-26.46,0c0,5.47,4,9.46,9,9.46s9-4,9-9.46c0-4.36-4-8.35-9-8.35S81.85,29.74,81.85,34.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.81,18.81H122l15.08,19.37h.09V18.81h8.23V50.49h-8.23L122.13,31.08H122V50.49h-8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.77,38.05l7.68-19.24h9L168.88,50.49h-6.39L149.17,18.81h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.11,25.79v5.29h9.28v7h-9.28v5.46h9.78v7h-18V18.81h18v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.57,50.49H225.32l-7.77-12.18h-.08V50.49h-8.24V18.81h12.31c6.26,0,11,3,11,9.75,0,4.37-2.44,8.15-6.93,9ZM217.47,33h.8c2.68,0,5.71-.5,5.71-3.95s-3-3.94-5.71-3.94h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.44,27a8.65,8.65,0,0,0-5.46-2.1c-1.51,0-3.53.89-3.53,2.65s2.23,2.56,3.66,3l2.1.63c4.41,1.31,7.81,3.53,7.81,8.66,0,3.15-.75,6.38-3.27,8.53a13.9,13.9,0,0,1-9,3,19.64,19.64,0,0,1-11.14-3.61l3.53-6.64c2.06,1.8,4.5,3.27,7.31,3.27,1.93,0,4-1,4-3.19s-3.23-3.11-5-3.61c-5.16-1.47-8.56-2.82-8.56-8.95,0-6.43,4.57-10.63,10.92-10.63a21.6,21.6,0,0,1,9.91,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.42,25.79v5.29h9.28v7h-9.28v5.46h9.79v7h-18V18.81h18v7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.12,18.81H301.8a15.84,15.84,0,1,1,0,31.68H290.12Zm8.24,24.7h1.85c4.91,0,9.11-2.68,9.11-8.86,0-5.67-3.74-8.86-9-8.86h-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.58,46.41a4.92,4.92,0,1,1-4.91-4.91A4.92,4.92,0,0,1,331.58,46.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345,45l-2.19,5.51H334.1l12.18-31.68h9L367.2,50.49h-8.78L356.36,45Zm5.75-16.38h-.08l-3.4,10.08h6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.67,50.49h-8.23V18.81h8.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 67.69,
    height: 67.69,
    rx: 10.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.42,46.61A12.06,12.06,0,0,1,27.12,45l-3.83,2.07,1.78-3.53A11.83,11.83,0,0,1,33,22.9c5.07-.1,9.43,3.36,11.32,7.36h6.41c-2.09-9-9.13-13.38-17.48-13.38a17.86,17.86,0,1,0,0,35.72A17.78,17.78,0,0,0,50.69,39.26h-6.4C42.47,44.26,38.28,46.52,33.42,46.61Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo-blue.009f62e42d6463a6db781c0c58b82e64.svg";
export { ForwardRef as ReactComponent };